/// <amd-module name="Build/Pipelines/PipelineDetailsDataService" />
import { IReadonlyObservableValue, ObservableValue } from 'VSS/Core/Observable';
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { PipelineDetailsData } from "Build/Client/Contracts/DataProvider";

export interface IPipelineDetailsDataService extends IVssService {
    data: IReadonlyObservableValue<PipelineDetailsData>;
    updateData: (pipelineDetails: PipelineDetailsData) => void;
    refreshData: () => void;
}

class PipelineDetailsDataService extends VssService implements IPipelineDetailsDataService {
    private _data: ObservableValue<PipelineDetailsData>;

    public get data(): IReadonlyObservableValue<PipelineDetailsData> {
        return this._data;
    }

    public updateData(pipelineDetails: PipelineDetailsData) {
        this._data.value = pipelineDetails;
    }

    public refreshData() {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        contributionService.getDataAsync<PipelineDetailsData>("ms.vss-build-web.pipeline-details-data-provider", { definitionId: this._data.value.definitionId.toString() }, true).then((value: PipelineDetailsData | undefined) => {
            if (value) {
                this._data.value = value;
            }
        });
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._initialize();
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
        this._initialize();
    }

    private _initialize() {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const data = contributionService.getData<PipelineDetailsData>("ms.vss-build-web.pipeline-details-data-provider");
        if (data) {
            if (this._data) {
                this._data.value = data;
            }
            else {
                this._data = new ObservableValue<PipelineDetailsData>(data);
            }
        }
    }
}

Services.add("IPipelineDetailsDataService", { serviceFactory: PipelineDetailsDataService });
